module.exports = __webpack_public_path__ + "img/jcht.b970223a.png";